import { useSelector } from 'react-redux';
import { emptyList } from '@constants/empty';
import { getActiveUidsByType } from '@models/Me';
import { getMe } from './auth';

export const getIsPlusEnrolled = (state) => getMe(state).isPlusEnrolled;

export const getMePlusSubscriptions = (state) =>
  getMe(state).plusSubscriptions || emptyList;

export const getMeLatestUserSubscriptions = (state) =>
  getMe(state).latestUserSubscriptions || emptyList;

export const LatestActiveUserSubscription = () => {
  const getMeLatestActiveUserSubscriptions = (state) =>
    getMe(state).latestUserSubscriptions || emptyList;
  const UserActiveSubscription = useSelector(
    getMeLatestActiveUserSubscriptions
  );
  const LatestActiveSubscription = UserActiveSubscription?.find(
    (userSubscription) => userSubscription.time_remaining > 0
  );
  return LatestActiveSubscription;
};

export const getPlusSubscriptionUIDs = (state) =>
  getMe(state).plusSubscriptionUids || emptyList;

export const getPlusWithoutTrialSubscriptionUIDs = (state) =>
  getMe(state).plusWithoutTrialSubscriptionUids || emptyList;

export const getIconicSubscriptionUIDs = (state) =>
  getMe(state).iconicSubscriptionUIDs || emptyList;

export const getActiveOfflineSubscriptionUIDs = (state) =>
  getMe(state).activeOfflineSubscriptionUIDs || emptyList;

export const getLiteSubscriptionUIDs = (state) =>
  getMe(state).liteSubscriptionUids || emptyList;

export const getPrePaymentPlusSubscriptionUIDs = (state) =>
  getMe(state).prePaymentPlusSubscriptionUids;

export const getIsSubscribed = (state) =>
  getPlusSubscriptionUIDs(state).length > 0;

export const getIsSubscribedToPlusWithoutTrial = (state) =>
  getPlusWithoutTrialSubscriptionUIDs(state).length > 0;

export const getPlusSubscriptionInfo = (goalUID) => (state) =>
  getMePlusSubscriptions(state).find(
    ({ subscription }) => subscription?.value.uid === goalUID
  );

export const getPlusSubscriptionInfoLatest = (goalUID) => (state) =>
  getMeLatestUserSubscriptions(state).find(
    ({ subscription }) => subscription?.value.uid === goalUID
  );

export const getIsSubscribedToGoal = (goalUID) => (state) => {
  if (!goalUID) {
    return false;
  }
  return getActiveUidsByType(getMe(state)).includes(goalUID.toUpperCase());
};

export const getIsSubscribedToPlus = (goalUID) => (state) => {
  if (!goalUID) {
    return false;
  }
  return getPlusSubscriptionUIDs(state).includes(goalUID.toUpperCase());
};

export const getIsSubscribedToIconic = (goalUID) => (state) => {
  if (!goalUID) {
    return false;
  }
  return getIconicSubscriptionUIDs(state).includes(goalUID.toUpperCase());
};

// adding a change here
export const getIsSubscribedToOffline = (goalUID) => (state) => {
  if (!goalUID) {
    return false;
  }
  return getActiveOfflineSubscriptionUIDs(state).includes(
    goalUID.toUpperCase()
  );
};

export const getIsSubscribedToLite = (goalUID) => (state) => {
  if (!goalUID) {
    return false;
  }
  return getLiteSubscriptionUIDs(state).includes(goalUID.toUpperCase());
};

export const getHasExpiredSubscriptionToGoal = (goalUID) => (state) => {
  if (!goalUID) {
    return false;
  }
  return (getMe(state)?.expiredSubscriptionsUids || []).includes(
    goalUID.toUpperCase()
  );
};
